/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert_message_container[_ngcontent-%COMP%]{position:fixed;top:0;left:0;display:flex;align-items:center;flex-direction:row;justify-content:center;width:100%}"];
export { styles as styles };
